// extracted by mini-css-extract-plugin
module.exports = {"questionPaymentMethod":"styles_questionPaymentMethod__3LPlu","input-extra-small":"styles_input-extra-small__3QsUk"};